import { tickerItems } from "@/mocks/homeContent";

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full border-y border-background-200/70 bg-background-100">
      <div className="flex h-12 items-center gap-4 px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-line text-sm"></i>
          </span>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8">
            {loop.map((text, index) => (
              <span
                key={`${index}-${text}`}
                className="flex items-center gap-2 text-sm text-foreground-600 whitespace-nowrap"
              >
                <span className="flex h-3 w-3 items-center justify-center text-secondary-500">
                  <i className="ri-record-circle-line text-xs"></i>
                </span>
                {text}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#subscribe"
          className="hidden shrink-0 cursor-pointer items-center gap-1 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex whitespace-nowrap"
        >
          订阅每日速递
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-arrow-right-s-line text-sm"></i>
          </span>
        </a>
      </div>
    </div>
  );
}